import { render, staticRenderFns } from "./lawyeroffice.vue?vue&type=template&id=3a3dcfa2&scoped=true&"
import script from "./lawyeroffice.vue?vue&type=script&lang=js&"
export * from "./lawyeroffice.vue?vue&type=script&lang=js&"
import style0 from "./lawyeroffice.vue?vue&type=style&index=0&id=3a3dcfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3dcfa2",
  null
  
)

export default component.exports